var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2fff/svg",
    width: 32.528,
    height: 25.31,
    viewBox: "0 0 32.528 25.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_236",
    "data-name": "Grupo 236",
    transform: "translate(-1687.594 -41.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M924.929,523.152h5.877l5.3,14.2h17.109l3.764-11.121",
    transform: "translate(762.665 -481.557)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    transform: "translate(1696.964 58.627)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.889,
    cy: 3.889,
    rx: 3.889,
    ry: 3.889,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.889,
    cy: 3.889,
    rx: 3.389,
    ry: 3.389,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    transform: "translate(1709.927 58.627)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.889,
    cy: 3.889,
    rx: 3.889,
    ry: 3.889,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.889,
    cy: 3.889,
    rx: 3.389,
    ry: 3.389,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarWhite);
export default __webpack_public_path__ + "static/media/car-white.3c011c57e41d4fc22cddff65e4314d82.svg";
export { ForwardRef as ReactComponent };